var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurgerMenuLtr = function SvgBurgerMenuLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.26a4 4 0 0 1 4-4h84a4 4 0 0 1 0 8H8a4 4 0 0 1-4-4m0 29.024a4 4 0 0 1 4-4h84a4 4 0 1 1 0 8H8a4 4 0 0 1-4-4m0 28.909a4 4 0 0 1 4-4h84a4 4 0 0 1 0 8H8a4 4 0 0 1-4-4"
  })));
};
export default SvgBurgerMenuLtr;